import React, { useMemo } from 'react';
import SubPage, { PageActions } from '#/common/components/SubPage';
import Expenses from '../components/Expenses';
import { useSearchParams } from 'react-router-dom';
import { PageAction } from '#/app/providers/PageProvider';

const ExpensesPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const workOrderId = searchParams.get('workOrderId') || undefined;
  const tenantId = searchParams.get('tenantId') || undefined;

  const params = [];

  if (workOrderId) params.push(`workOrderId=${workOrderId}`);
  if (tenantId) params.push(`tenantId=${tenantId}`);

  const newPath = `/expenses/new${params.length > 0 ? `?${params.join('&')}` : ''}`;

  const actions = useMemo<PageAction[]>(
    () => [
      {
        id: 'new-expense',
        alwaysShow: true,
        type: 'button',
        props: {
          type: 'submit',
          label: 'Create New Expense',
          icon: 'add',
          responsive: true,
          path: newPath,
        },
      },
    ],
    [newPath],
  );

  return (
    <SubPage title="Expenses" type="list">
      <PageActions actions={actions} />
      <Expenses hideNewAction />
    </SubPage>
  );
};

export default React.memo(ExpensesPage);
